import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../../dashboard.selectors';
import * as fromCcStudyParticipant from './cc-study-participant.reducer';

export const selectCcStudyParticipantState = createSelector(
  selectDashboardState,
  (dashboard) => dashboard?.ccStudyParticipant
);

export const selectIsLoadingCcStudyParticipants = createSelector(
  selectCcStudyParticipantState,
  (ccStudyParticipantState) => ccStudyParticipantState?.loadingCcStudyParticipants
);

export const selectCcStudyParticipantsLoaded = createSelector(
  selectCcStudyParticipantState,
  (ccStudyParticipantState) => ccStudyParticipantState?.ccStudyParticipantsLoaded
);

export const selectCcStudyParticipants = createSelector(
  selectCcStudyParticipantState,
  fromCcStudyParticipant.selectAll
);
